module.exports = __webpack_public_path__ + "img/mobile_payments.a6d74b09.jpg";